import React from "react";
import ReactDOM from "react-dom/client";
import App from "./Components/App";
//import "./Style/main.scss";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);
